export default "__VITE_ASSET__xWwRDBzG__"